import { render, staticRenderFns } from "./PersonHero.vue?vue&type=template&id=0caf42fd&scoped=true"
import script from "./PersonHero.vue?vue&type=script&lang=js"
export * from "./PersonHero.vue?vue&type=script&lang=js"
import style0 from "./PersonHero.vue?vue&type=style&index=0&id=0caf42fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf42fd",
  null
  
)

export default component.exports